import { FIELD_TYPES } from '../../../../shared/constants/global';

import { type FieldSchema, type ValidatorContext } from './types';
import {
  createBooleanValidator,
  createCheckboxValidator,
  createDateValidator,
  createMultiSelectValidator,
  createNumberValidator,
  createPasswordValidator,
  createRadioValidator,
  createSensitiveValidator,
  createSingleSelectValidator,
  createTermsAndConditionsValidator,
  createTextareaValidator,
  createTextValidator,
} from './validators';

/**
 * Factory function that creates a Yup validator based on field type
 */
const createFieldValidator = (
  context: ValidatorContext
): FieldSchema | null => {
  const { field } = context;

  if (!('fieldType' in field)) {
    return null;
  }

  switch (field.fieldType) {
    case FIELD_TYPES.TEXT:
      return createTextValidator(context);

    case FIELD_TYPES.TEXTAREA:
      return createTextareaValidator(context);

    case FIELD_TYPES.SENSITIVE:
      return createSensitiveValidator(context);

    case FIELD_TYPES.PASSWORD:
      return createPasswordValidator(context);

    case FIELD_TYPES.NUMBER:
      return createNumberValidator(context);

    case FIELD_TYPES.DATE:
      return createDateValidator(context);

    case FIELD_TYPES.SINGLESELECT:
      return createSingleSelectValidator(context);

    case FIELD_TYPES.MULTISELECT:
      return createMultiSelectValidator(context);

    case FIELD_TYPES.RADIO:
      return createRadioValidator(context);

    case FIELD_TYPES.CHECKBOX:
      return createCheckboxValidator(context);

    case FIELD_TYPES.BOOLEAN:
      return createBooleanValidator(context);

    case FIELD_TYPES.TERMSANDCONDITIONS:
      return createTermsAndConditionsValidator(context);

    default:
      return null;
  }
};

export default createFieldValidator;
